import { retrieveMiniCart } from './_retrieveMiniCart';
import { retrieveWishListInfo } from './_retrieveWishListInfo';
import { retrieveOrderHistory } from './_retrieveOrderHistory';

const swapMyDillardsButtons = (caller) => {
	$('#addedToWishlist-error-alert').remove();
	$('#myDillardsDropDown .focused-btn').removeClass('focused-btn');
	$(caller).addClass('focused-btn');

	if ($(caller).text() === 'Shopping Bag') retrieveMiniCart('MyDillardsShoppingBag');
	else if ($(caller).text() === 'Wish List') retrieveWishListInfo();
	else if ($(caller).text() === 'Purchase History') retrieveOrderHistory();
	else if ($(caller).text() === 'Reasons to Register')
		$('#myDillardsDropdownDynamic').html(
			'<p>Here are some benefits you will enjoy as a registered Dillards.com user</p>' +
				'<ul>' +
				'<li>Quick Checkout</li>' +
				'<li>Wish Lists</li>' +
				'<li>Manage eGift Cards</li>' +
				'<li>Purchase History / Order Tracking</li>' +
				'</ul>'
		);
};
export { swapMyDillardsButtons };
